/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import { schemaGenerator } from "~helpers/schema";
import keygen from "~helpers/keygen";
import {
  getUrl,
  getLanguage,
  getPageImage,
  imagePrettyUrl,
} from "~helpers/getters";
import { getMetaTags, getCanonicalUrl } from "~helpers/head";
import customData from "./customData";

const HeadData = ({ page = {} }) => {
  const isTracker = page.template === "tracker";
  const metaTags = getMetaTags(page, isTracker);
  const pageImage = getPageImage(page) || imagePrettyUrl(page.siteInfo?.site_logo);

  let defaultHref = null;

  return (
    <>
      <title>{page.meta_title}</title>
      <html lang={process.env.GATSBY_SITE_LANG || getLanguage(page.language)} />
      {metaTags}
      {customData(page)}
      {process.env.GATSBY_ACTIVE_ENV === "development" && (
        <meta name="googlebot" content="noindex,follow" />
      )}
      <link rel="canonical" href={getCanonicalUrl(page, isTracker)} />\
      {page?.hreflangs?.map((link) => {
        if (link?.default) {
          defaultHref = link?.path;
        }
        return (
          <link
            key={keygen()}
            rel="alternate"
            href={getUrl(link.path)}
            hrefLang={link.language}
          />
        );
      })}
      {defaultHref && (
        <link rel="alternate" href={getUrl(defaultHref)} hrefLang="x-default" />
      )}
      {page.preconnect_links &&
        page.preconnect_links.map((link) => (
          <link key={keygen()} rel="preconnect" href={link} />
        ))}
      {schemaGenerator(page, pageImage).map(
        (schema) =>
          schema && (
            <script key={keygen()} type="application/ld+json">
              {`${schema}`}
            </script>
          )
      )}
    </>
  );
};

HeadData.propTypes = {
  siteInfo: PropTypes.shape({
    robots_txt: PropTypes.string,
    site_logo: PropTypes.string,
    site_name: PropTypes.string,
  }),
  page: PropTypes.shape({
    meta_title: PropTypes.string,
    language: PropTypes.string,
    meta_description: PropTypes.string,
    meta_robots: PropTypes.arrayOf(PropTypes.string),
    path: PropTypes.string,
    preconnect_links: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default HeadData;
